import React from 'react'
import { Box, Typography, Checkbox } from '@mui/material'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import GetAppIcon from '@mui/icons-material/GetApp'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { withStyles } from '@mui/styles'

import { OUTRANGED_APPS, PENDING_APPS, ACCEPTED_APPS } from '../constants/status-po.constants'
import { publicOfferStyles } from './add-public-offers.styles'
import { ORIGEN_KEYS, ORIGEN_KEYS_PRESCRIPTOR } from '../constants'

export const PublicOfferViewer = withStyles(publicOfferStyles)(({
  classes,
  publicOffer,
  handleShowFile,
  handleDownloadFile,
  handleCheckPublicOffer,
  docsReaded,
  publicOffersToSend,
  generalConditions,
  company,
  disabled = false,
}) => {
  const { formatMessage } = useIntl()
  const role = useSelector((state) => state.global.role)
  const origenKeys = role === 'administrador_prescriptor' ? ORIGEN_KEYS_PRESCRIPTOR : ORIGEN_KEYS

  return (
    <Box width={'100%'}>
      {origenKeys.map((origen) => (
        <>
          <Box mt={1}>
            <Typography className={classes.origen}>
              <Box sx={{ fontWeight: 'bold' }}>
                {formatMessage({
                  id: `pages.profile.company.guild.info.publicOffer.market.origen.label.${origen}`,
                })}
              </Box>
            </Typography>
          </Box>
          <Box display="flex" flexDirection="column" mt={1}>
            {publicOffer?.campañas[origen].length > 0 ? (
              publicOffer.campañas[origen].map((po, i) =>
                !OUTRANGED_APPS[po.estado] ? (
                  <Box key={i} display="flex" justifyContent="space-between" alignItems="center">
                    <Box alignItems="center" display="flex" ml={1}>
                      <Typography>
                        {po.financiacion ? `${po.nombre} - FINANCIACION` : po.nombre}
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" mr={1}>
                      {po.financiacion && po.d_condiciones_economicas?.id ? (
                        <PictureAsPdfIcon
                          className={
                            docsReaded.includes(po.id) ||
                            PENDING_APPS[po.estado] ||
                            ACCEPTED_APPS[po.estado]
                              ? classes.docCheked
                              : classes.noChecked
                          }
                          onClick={() => handleShowFile(po.d_condiciones_economicas.id, po.id)}
                        />
                      ) : !po.financiacion ? (
                        <PictureAsPdfIcon
                          className={
                            docsReaded.includes(po.id) ||
                            PENDING_APPS[po.estado] ||
                            ACCEPTED_APPS[po.estado]
                              ? classes.docCheked
                              : classes.noChecked
                          }
                          onClick={() => handleShowFile(po.d_condiciones_economicas.id, po.id)}
                        />
                      ) : null}
                      <Box ml={1}>
                        <Typography>{formatMessage({ id: 'global.accept' })}</Typography>
                      </Box>
                      <Checkbox
                        disabled={
                          PENDING_APPS[po.estado] ||
                          ACCEPTED_APPS[po.estado] ||
                          !generalConditions ||
                          !company.check_resp_sec_info ||
                          disabled
                        }
                        onChange={() => handleCheckPublicOffer(po.id, po.estado, po.financiacion)}
                        checked={
                          ACCEPTED_APPS[po.estado] ||
                          PENDING_APPS[po.estado] ||
                          publicOffersToSend?.includes(po.id)
                        }
                      ></Checkbox>
                      {po.financiacion && po.d_condiciones_economicas?.id ? (
                        <GetAppIcon
                          className={classes.download}
                          onClick={() => handleDownloadFile(po.d_condiciones_economicas.id)}
                        />
                      ) : !po.financiacion ? (
                        <GetAppIcon
                          className={classes.download}
                          onClick={() => handleDownloadFile(po.d_condiciones_economicas.id)}
                        />
                      ) : null}
                    </Box>
                  </Box>
                ) : null
              )
            ) : (
              <Box alignItems="center" display="flex" ml={1} mt={1} mb={1}>
                {formatMessage({
                  id: 'pages.profile.company.guild.info.publicOffer.noOffers.market.origin',
                })}
              </Box>
            )}
          </Box>
        </>
      ))}
    </Box>
  )
})
